import { render } from "./AddTileGameContent.vue?vue&type=template&id=23771a6e"
import script from "./AddTileGameContent.vue?vue&type=script&lang=js"
export * from "./AddTileGameContent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__